import { render } from "./ChatPage.vue?vue&type=template&id=304b33eb&scoped=true"
import script from "./ChatPage.vue?vue&type=script&lang=js"
export * from "./ChatPage.vue?vue&type=script&lang=js"

import "./ChatPage.vue?vue&type=style&index=0&id=304b33eb&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304b33eb"]])

export default __exports__